import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetVendorBalancesSummaryQuery } from "../../../services/Reports";
import {
  getVendorBalancesSummaryRequest,
  getVendorBalancesSummaryFailure,
  getVendorBalancesSummarySuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allVendorBalancesSummary,
    isLoading: vendorBalancesSummaryLoading,
    isError: vendorBalancesSummaryError,
  } = useGetVendorBalancesSummaryQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.vendorBalancesSummaryPageNo,
    pageSize: state.vendorBalancesSummaryPageSize,
    fromDate: new Date(
      state.vendorBalancesSummaryFromDate,
    ).toLocaleDateString(),
    toDate: new Date(state.vendorBalancesSummaryToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (vendorBalancesSummaryLoading) {
      dispatch(getVendorBalancesSummaryRequest());
    }
    if (vendorBalancesSummaryError) {
      dispatch(getVendorBalancesSummaryFailure(vendorBalancesSummaryError));
    }
    if (allVendorBalancesSummary) {
      dispatch(
        getVendorBalancesSummarySuccess({
          data:
            allVendorBalancesSummary.data.allVendorBalancesSummary[0].data ||
            [],
          totalPages:
            allVendorBalancesSummary.data.allVendorBalancesSummary[0]
              .metadata[0]?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allVendorBalancesSummary,
    profileData,
    state.vendorBalancesSummaryFromDate,
    state.vendorBalancesSummaryToDate,
    state.vendorBalancesSummaryPageNo,
    state.vendorBalancesSummaryPageSize,
  ]);
  return <></>;
};
export default Content;
